import React from 'react';
import { Link } from 'react-router-dom';
import {
  Breadcrumb, Form, Input, Button, Switch, DatePicker, Upload, Space, Select, Row, Col, Tag, Checkbox,
} from 'antd';
import { useTranslation } from 'react-i18next';
import { PlusOutlined } from '@ant-design/icons'; 

import withAuth from '@common/hocs/withAuth';
import MainLayout from '@common/layouts/MainLayout'; 

import useClientesEditCreate from './useClientesEditCreate';
import styles from './ClientesEditCreate.module.less';
import { faUpload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Text from 'antd/lib/typography/Text'; 

import { ReactComponent as companyIcon } from '@assets/svg/company.svg';
import { ReactComponent as energyIcon } from '@assets/svg/energy.svg';  

import Icon from '@ant-design/icons/lib/components/Icon';
import TextArea from 'antd/lib/input/TextArea';
 

const iconProps = {
  className: 'anticon',
  style: { fontSize: 10, minWidth: 'auto', color:'#828282' },
};

const progressBarUpload = {
  strokeColor: {
    '0%': '#108ee9',
    '100%': '#87d068',
  },
  strokeWidth: 3,
  format: (percent) => `${parseFloat(percent.toFixed(2))}%`,
};

const { Dragger } = Upload;

function ClientesEditCreate() {

  const { t } = useTranslation();
  const {
    onFinishFailed, onFinish,
    formOnValuesChange,     
    dataForm,
    idToEdit,
    businessData,
    cancelCreateEditUser, 
    onChangeRepresentative,
    loadingForm,
    onDataChange,
    devicesData,
    typeCommunity,
    form
  } = useClientesEditCreate();
   
  return (
    <MainLayout applyWidthLimit>
      <div className={styles.wrapper}>
        <Breadcrumb className={styles.date_wrapper}>
          <Breadcrumb.Item className={styles.breadcrumb}>
            <Link to="/clientes">{t('views.users.breadcrumb.clients')}</Link>
          </Breadcrumb.Item>
          {(idToEdit)
            ? (
              <>
                <Breadcrumb.Item className={styles.breadcrumb}>{t('forms.clients.update_title')}</Breadcrumb.Item>
                <Breadcrumb.Item className={styles.breadcrumb}>{idToEdit}</Breadcrumb.Item>
              </>
            )
            : <Breadcrumb.Item className={styles.breadcrumb}>{t('forms.clients.create_title')}</Breadcrumb.Item>}
        </Breadcrumb>

         {/* Primera fila */}
 
        <Form
          form={form}
          name="CreateClient"
          labelCol={{ span: 10 }}
          wrapperCol={{ span: 22 }}
          layout="vertical"
          className={styles.totalForm}
          initialValues={{
            ...dataForm, remenber: true,
          }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          onValuesChange={formOnValuesChange}
          autoComplete="off"
        >

          <Row gutter={16}> 
              <Col span={24}>
                <div> 
                    <h2 style={{marginBottom:0}}>{(idToEdit)?t('forms.clients.update_title'):t('forms.clients.create_title')}</h2> 
                </div>
              </Col>
          </Row> 

          <Row gutter={16} style={{marginTop:15}}> 
              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <Form.Item
                  className={styles.label}
                  label={t('forms.clients.labels.celsia_id')}
                  name="celsia_id"
                  rules={[
                    { required: true, message: t('forms.clients.rules.celsia_id') },
                  ]}
                >
                  <Input className={styles.input} placeholder={t('forms.clients.placeholders.celsia_id')} />
                </Form.Item>
              </Col>

              <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                <Form.Item
                    className={styles.label}
                    label={t('forms.clients.labels.id_tercero')}
                    name="third_id"
                    rules={[
                      { required: true, message: t('forms.clients.rules.id_tercero') },
                    ]}
                  >
                  <Input className={styles.input} placeholder={t('forms.clients.placeholders.id_tercero')} />
                </Form.Item>
              </Col> 

              <Col xs={24} sm={24} md={12} lg={12} xl={12}> 
                <Form.Item
                    className={styles.short_input}
                    label={t('forms.users.labels.business_line')}
                    name="business_type_id" //business_type
                    rules={[
                      {
                        required: true,
                        message: t('forms.users.placeholders.business_line'),
                      },
                    ]}
                  >
                    <Select 
                      onChange={(value) => onDataChange(value)} 
                      disabled={idToEdit}
                      style={{ width: '100%' }} 
                      placeholder={t('forms.users.placeholders.business_line')} 
                      options={businessData}

                    /> 
                </Form.Item>
              </Col>
              
              {
                typeCommunity && typeCommunity === 'AmiIoT' &&
                <Col xs={24} sm={24} md={12} lg={12} xl={12}> 
                  <Form.Item
                      className={styles.label}
                      label={t('forms.users.labels.devices')}
                      name="devices_id"
                      rules={[
                      {
                        required: true,
                        message: t('forms.users.placeholders.devices'),
                      },
                    ]}
                    >
                      <Select
                        allowClear
                        style={{ width: '100%' }}
                        placeholder={t('forms.users.placeholders.devices')} 
                        options={devicesData}
                      /> 
                  </Form.Item>
                </Col>
              } 

              <Col xs={24} sm={24} md={12} lg={12} xl={12}> 
                <Form.Item
                  className={styles.label}
                  label={t('forms.clients.labels.estrato')}
                  name="stratum"
                  rules={[
                    { required: true, message: t('forms.clients.rules.estrato') },
                  ]}
                >
                  <Select 
                    style={{ width: '100%' }}
                    placeholder={t('forms.clients.placeholders.estrato')}
                    options={[ 
                      { value: 1, label: t('forms.clients.placeholders.estrato_select',{ index: '1'}) },
                      { value: 2, label: t('forms.clients.placeholders.estrato_select',{ index: '2'}) },
                      { value: 3, label: t('forms.clients.placeholders.estrato_select',{ index: '3'}) },
                      { value: 4, label: t('forms.clients.placeholders.estrato_select',{ index: '4'}) },
                      { value: 5, label: t('forms.clients.placeholders.estrato_select',{ index: '5'}) },
                    ]}
                  /> 
                </Form.Item>
              </Col>

              <Col xs={24} sm={24} md={12} lg={12} xl={12}> 
                <Form.Item
                  className={styles.label}
                  label={t('forms.clients.labels.community_rep')}
                  name="representative"
                >
                  <Checkbox checked={dataForm.representative}
                  onChange={(e) => onChangeRepresentative(e.target.checked)}>
                  {t('forms.clients.placeholders.community_rep')}</Checkbox>
                </Form.Item>
              </Col>

              <Col xs={24} sm={24} md={12} lg={12} xl={12}> 
              <Form.Item
                  className={styles.label}
                  label={t('forms.clients.labels.description')}
                  name="description"
                  rules={[
                    { required: true, message: t('forms.clients.rules.description') },
                  ]}
                >
                 <TextArea className={styles.text_area} rows={3} placeholder={t('forms.clients.placeholders.description')} />
                </Form.Item>
              </Col> 
          </Row> 
      
          <Row style={{marginTop:25, justifyContent:'end'}}>
              
              <Button key="back" className='m_l' onClick={() => cancelCreateEditUser()}>
                <span className={styles.textTag2}>{t('forms.clients.buttons.cancel')}</span>
              </Button>

              <Button key="button" loading={loadingForm} className='m_l' type="primary" htmlType="submit" icon={(!idToEdit) ?<PlusOutlined />:null} >
               {(!idToEdit) ? t('forms.clients.buttons.create') : t('forms.clients.buttons.update') }
              </Button> 
              
          </Row>
        </Form>
      </div> 

    </MainLayout>
  );

}

export default withAuth(ClientesEditCreate);
